module.exports = __webpack_public_path__ + "media/customizations/windsong/logo-845164e4a5dc633df87ffd0de6fad20d.png";